export default __webpack_public_path__ + "e68630a3bcbf701ea803321edfa80ab5.png";